/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ErrorResponseErrorsInner } from './ErrorResponseErrorsInner';
import {
    ErrorResponseErrorsInnerFromJSON,
    ErrorResponseErrorsInnerFromJSONTyped,
    ErrorResponseErrorsInnerToJSON,
    ErrorResponseErrorsInnerToJSONTyped,
} from './ErrorResponseErrorsInner';

/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    message: string;
    /**
     * 
     * @type {Date}
     * @memberof ErrorResponse
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    path: string;
    /**
     * 
     * @type {Array<ErrorResponseErrorsInner>}
     * @memberof ErrorResponse
     */
    errors?: Array<ErrorResponseErrorsInner>;
}

/**
 * Check if a given object implements the ErrorResponse interface.
 */
export function instanceOfErrorResponse(value: object): value is ErrorResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('path' in value) || value['path'] === undefined) return false;
    return true;
}

export function ErrorResponseFromJSON(json: any): ErrorResponse {
    return ErrorResponseFromJSONTyped(json, false);
}

export function ErrorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'timestamp': (new Date(json['timestamp'])),
        'path': json['path'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(ErrorResponseErrorsInnerFromJSON)),
    };
}

export function ErrorResponseToJSON(json: any): ErrorResponse {
    return ErrorResponseToJSONTyped(json, false);
}

export function ErrorResponseToJSONTyped(value?: ErrorResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'message': value['message'],
        'timestamp': ((value['timestamp']).toISOString()),
        'path': value['path'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(ErrorResponseErrorsInnerToJSON)),
    };
}

